import { Close, CropFree, Print } from '@mui/icons-material';
import {
  Alert,
  AppBar,
  Container,
  Dialog,
  Grid,
  IconButton,
  Stack,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { InductionRoute } from '@helpers/types';
import { useInductionArea } from '@components/induction-area/use-induction-area.ts';
import { TableInduction } from '@components/induction-area/childs/table.tsx';
import { SquareInfo } from '@components/induction-area/childs/square-info.tsx';

interface IInductionAreaProps {
  onClose: () => void;
  routes: Array<InductionRoute>;
}

export const InductionArea = (props: IInductionAreaProps) => {
  const { routes, onClose } = props;

  const {
    error,
    loading,
    inputRef,
    toInduct,
    progress,
    currStation,
    onKeyEnter,
    inductedOnly,
    connectDevice,
    success_induct,
    onChangeTracking,
    connectedPrinter,
    inducted_containers: _inducted_containers,
    onPrintContainer,
  } = useInductionArea(routes, onClose);

  return (
    <Dialog fullScreen open={true}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => onClose()}>
            <Close />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {`Inducción a [${currStation?.station}]`}
          </Typography>

          <Tooltip title="Conectar impresora">
            <IconButton color="inherit" onClick={connectDevice} size="large">
              <Print />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Container sx={{ py: 3 }} maxWidth="xl">
        <Stack spacing={3}>
          {/* Alertas superiores */}
          {(!connectedPrinter || error) && (
            <Stack spacing={1}>
              {!connectedPrinter && (
                <Alert severity="error">
                  La impresora no se encuentra conectada
                </Alert>
              )}
              {error && (
                <Alert severity="error">
                  {error}
                </Alert>
              )}
            </Stack>
          )}

          <Grid container spacing={3}>
            {/* Tabla de rutas */}
            <Grid size={{ xs: 12, lg: 4 }}>
              <TableInduction
                routes={routes}
                progress={progress}
                onPrintContainer={onPrintContainer}
              />
            </Grid>

            {/* Sección central de escaneo */}
            <Grid size={{ xs: 12, lg: 8 }}>
              <Stack spacing={3} alignItems="center">
                <TextField
                  autoFocus
                  fullWidth
                  value={toInduct}
                  autoComplete="off"
                  variant="outlined"
                  disabled={loading}
                  inputRef={inputRef}
                  onChange={onChangeTracking}
                  placeholder="Escanear paquete"
                  sx={{ maxWidth: 600 }}
                  InputProps={{
                    sx: {
                      padding: 1.5,
                      fontSize: '1.5rem',
                      borderRadius: '2.5rem',
                    },
                    startAdornment: (
                      <CropFree
                        color="primary"
                        fontSize="large"
                        sx={{ marginRight: '1rem' }}
                      />
                    ),
                  }}
                  onKeyDown={onKeyEnter}
                />

                {success_induct && (
                  <Stack spacing={3} alignItems="center" sx={{ width: '100%', maxWidth: 600 }}>
                    <Stack direction="row" spacing={2} alignItems="baseline">
                      <Typography
                        variant="overline"
                        color="text.secondary"
                        fontWeight="bold"
                        fontSize="1.1rem"
                      >
                        Orden:
                      </Typography>
                      <Typography variant="h3" color="primary" fontWeight="medium">
                        {success_induct.tracking_id}
                      </Typography>
                    </Stack>

                    {inductedOnly ? (
                      <SquareInfo label="Inducido" value="Sí" />
                    ) : (
                      <Stack direction="row" spacing={3} justifyContent="center">
                        <SquareInfo
                          label="Ruta"
                          value={success_induct.route_name}
                        />
                        <SquareInfo
                          label="Parada"
                          value={success_induct.delivery_order}
                        />
                      </Stack>
                    )}
                  </Stack>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Container>
    </Dialog>
  );
};
